export default {"src":"/_next/static/media/apple-appstore-badge-nl.2ce1adc6.svg","height":40,"width":120,"blurWidth":0,"blurHeight":0};